<h1> COOKIE POLICY </h1>
<div class="text">
	<p>
		Questo sito non fa uso di cookies, né di prima né di terza parte,
		e non memorizza in alcun modo le tue informazioni.
	</p>
	<p> <b> Cosa sono i cookies: </b>
		<br>
		I cookie sono piccoli frammenti di testo inviati al browser di un utente da un sito web visitato.
		Il loro utilizzo permette ad un sito di conservare informazioni relative alla visita e mantenerle
		tra diverse sessioni.
	</p>
	<p>
		I cookie possono essere di prima parte, generati direttamente dal sito web che stai visitando,
		o di terza parte, generati da dei domini esterni che forniscono un servizio al sito web
		(per esempio servizi pubblicitari, o di condivisione social).
	</p>
</div>